import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    background: theme.palette.background.paper,
    minWidth: theme.spacing(34),
    zIndex: 1,
    height: '100%',
    left: 0,
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },

  container: {
    listStyle: 'none',
    margin: theme.spacing(0),
    padding: theme.spacing(1.875, 0),
    overflowY: 'auto',

    '& .MuiDivider-root': {
      marginTop: theme.spacing(1.875),
      marginBottom: theme.spacing(0),
    },

    '&: > *': {
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,

      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },

  navigationItem: {
    padding: theme.spacing(0.625, 1.875),
    marginBottom: theme.spacing(1.25),
  },

  gameNavigationItem: {
    marginBottom: theme.spacing(1.25),
  },
}));
